import { createFileRoute } from "@tanstack/react-router";
import { ConsentPage } from "../../../components/auth/consent-page";
import { searchString } from "../../../lib/search";

interface ConsentSearch {
  client_id?: string;
  scope?: string;
}

/**
 * AI-connector consent. Better Auth sends people here with a signed query;
 * other params are left in the URL for the oauthProviderClient plugin.
 */
export const Route = createFileRoute("/_authed/oauth/consent")({
  validateSearch: (search: Record<string, unknown>): ConsentSearch => {
    const out: ConsentSearch = {};
    const clientId = searchString(search.client_id);
    const scope = searchString(search.scope);
    if (clientId !== undefined) out.client_id = clientId;
    if (scope !== undefined) out.scope = scope;
    return out;
  },
  component: ConsentRoute,
});

function ConsentRoute() {
  const { client_id, scope } = Route.useSearch();
  return <ConsentPage clientId={client_id ?? null} scope={scope ?? ""} />;
}
